import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cnaeClassReadAction from './cnaeClassRead.action.json' assert { type: 'json' }

const cnaeClassReadDefinition = defineReadAutoAction(cnaeClassReadAction, 'cnaeClass')

export default cnaeClassReadDefinition
